require('babel-polyfill')
const gc = require("../config/gc");
const puppeteer = require('puppeteer');
const path = require("path");
require('dotenv').config()

const bucket = gc.bucket(process.env.GOOGLEBUCKET_KEY || "billbook_stage");

const uploadFile = async (filePath, destFileName) => {
    return new Promise((resolve,reject) => {
        bucket.upload(filePath, {
            destination: destFileName,
        }, (err, file) => {
            if (err) {
                reject(err)
            }
            resolve("https://storage.googleapis.com/"+ bucket.name + "/" + destFileName);
        });
    }) 
}

const pdfGen = async (html, format, destination) => {
    try {
      // When we have to deploy in GC we have to correct this executable path!
      let executablePath = path.join(__dirname , '../../node_modules/puppeteer/.local-chromium/linux-1002410/chrome-linux/chrome');
        let puppeteerOptions = {
          headless: true,
          args: [
              '--no-sandbox',
              '--disable-web-security',
              '--disable-features=IsolateOrigins',
              '--disable-site-isolation-trials',
              '--disable-setuid-sandbox',
          ],
        };

        if(process.env.NODE_ENV == 'development'){
          puppeteerOptions = {
            executablePath: executablePath,
            ...puppeteerOptions,
          };
        }

        const browser = await puppeteer.launch(puppeteerOptions);
        const page = await browser.newPage();
        await page.setContent(html, { waitUntil: 'networkidle0' });
        await page.emulateMediaType("screen");
        let pdfOptions = {
            format: format,
            printBackground: true,
            displayHeaderFooter: false,
            scale: 1.5,
          };
        const buffer = await page.pdf(pdfOptions);
        let url = uploadBuffertoGc(buffer,destination);

        await browser.close();
        return url;
    } catch (err) {
      throw err;
    }
  }

  const uploadBuffertoGc = async(buffer,destination) => {
    try{
        let blob = bucket.file(destination);
        const blobStream = blob.createWriteStream({
            resumable: false,
            metadata: {
                contentType: 'application/pdf',
            },
        });
          return new Promise(function (resolve, reject) {
        blobStream.on('error', (err) => {
          reject(`Error to blob stream, something went wrong`);
        }).on('finish', () => {
          const publicUrl = `https://storage.googleapis.com/${bucket.name}/${blob.name}`;
          resolve(publicUrl);
        }).end(buffer);
      });

    }catch (err){
        throw err;
    }
  }

module.exports = {uploadFile,
                 pdfGen}
